import type { NavItem } from '../types/content'

/** Top utility bar of the Town's site, above the main navigation. */
export const utilityLinks: string[] = [
  'News',
  'Events',
  'Business Directory',
  'Community Directory',
  'Employment Opportunities',
  'Contact Us',
]

export const navItems: NavItem[] = [
  {
    label: 'Town Council',
    children: [
      'Mayor and council',
      'Council agendas and minutes',
      'Council highlights',
      'Committees and structure',
      'Financial statements',
      'Budgets',
      'Grants',
    ],
  },
  {
    label: 'Services & Departments',
    children: [
      'Property taxes',
      'Utilities',
      'Garbage and recycling collection',
      'Public works',
      'Planning and development',
      'Permits',
      'Emergency services',
      'Municipal enforcement',
    ],
  },
  {
    label: 'Business Resources',
    children: [
      'Business licensing',
      'Business opportunities',
      'Economic development',
      'Commercial tax incentive program',
      'Downtown revitalization program',
      'Tenders and RFPs',
      'Business directory',
    ],
  },
  {
    label: 'Exploring Bonnyville',
    children: [
      'Attractions',
      'Parks and recreation',
      'Bonnyville Swimming Pool',
      'Community directory',
      'Getting to Bonnyville',
      "Bonnyville's history",
      'Neighbouring communities',
    ],
  },
]
